/* VEXiAL — la lista de deseos, en un solo sitio.

   Había tres implementaciones copiadas (ficha de producto, tarjetas de
   colección, tarjetas de destacados) escribiendo el mismo
   localStorage con formas distintas, y cinco copias del contador del
   header.

   Lo grave no era la duplicación sino que dentro de UN MISMO elemento
   guardado el precio y la variante no se correspondían: la tarjeta
   guardaba el id de la variante "seleccionada o primera disponible"
   junto al precio MÍNIMO del producto. En 33 de los 76 productos esos
   dos números no son el mismo. Comprobado en la tienda:

     kit-completo-planos-para-accesorios-de-sujecion
       tarjeta ->  variantId 43836485894243 ("Español", $36.00)
                   price 34   <- el de la variante "Ingles"
       la lista mostraba "$34.00 USD" y al carrito iba la de $36.00

   Forma canónica (v:2). El precio va SIEMPRE en centavos y en la
   moneda de la tienda; convertir es cosa de quien pinta. Es lo que
   pide MONEDA-SOLES.md §6.3 para que el interruptor de soles no deje
   guardados precios que mienten al volver en otra moneda.

     { v, variantId, productId, name, variantName, image,
       priceCents, currency, handle, link, addedOn }

   Lo guardado con la forma vieja (sin `v`, con `price` en dólares) se
   migra al leerlo, así que las listas que ya tienen los clientes en su
   navegador siguen funcionando.

   En modo soles la lista es una superficie con «≈» (MONEDA.md §5): solo
   guarda dólares, así que el sol que muestre será siempre la conversión,
   aunque la ficha tenga uno fijado a mano.

   Se carga con defer desde layout/theme.liquid. Los scripts inline de
   las secciones corren antes, durante el parseo, así que no leen el
   estado de la lista al construir las tarjetas: los corazones los pinta
   syncHearts() en DOMContentLoaded, y los clics llegan cuando el módulo
   ya existe. */
(function () {
  'use strict';

  var KEY = 'vxw_items';

  /* "Default Title" es lo que Shopify le pone a la única variante de un
     producto sin opciones. No es un nombre, es un relleno: no se
     muestra ni se guarda. */
  function variantLabel(title) {
    if (!title || title === 'Default Title') return '';
    return String(title);
  }

  function activeCurrency() {
    return (window.VXMoney && window.VXMoney.currency())
      || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      || 'USD';
  }

  /* Deja cualquier elemento -- recién armado o leído de una versión
     anterior -- en la forma canónica. Devuelve null si no se puede
     identificar la variante, que es lo único imprescindible. */
  function normalize(raw) {
    if (!raw || !raw.variantId) return null;

    var priceCents;
    if (raw.priceCents != null && isFinite(Number(raw.priceCents))) {
      priceCents = Math.round(Number(raw.priceCents));
    } else {
      /* v1: `price` venía en dólares, a veces entero y a veces con
         decimales. */
      priceCents = Math.round((parseFloat(raw.price) || 0) * 100);
    }

    var image = raw.image || '';
    /* Las tarjetas guardaban la URL con protocolo relativo ("//cdn…")
       y la ficha con https. Se normaliza para que la misma imagen no
       se vea como dos. */
    if (image.indexOf('//') === 0) image = 'https:' + image;

    var variantId = String(raw.variantId);
    var link = raw.link || (raw.handle ? '/products/' + raw.handle : '');
    /* Sin ?variant= el enlace abre la variante por defecto, que puede
       no ser la guardada. Las tarjetas lo omitían. */
    if (link && link.indexOf('variant=') < 0) {
      link += (link.indexOf('?') < 0 ? '?' : '&') + 'variant=' + variantId;
    }

    return {
      v: 2,
      variantId: variantId,
      productId: raw.productId == null ? '' : String(raw.productId),
      name: raw.name || '',
      variantName: variantLabel(raw.variantName),
      image: image,
      priceCents: priceCents,
      currency: raw.currency || activeCurrency(),
      handle: raw.handle || '',
      link: link,
      addedOn: raw.addedOn || new Date().toISOString()
    };
  }

  function get() {
    var raw;
    try { raw = JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
    if (!Array.isArray(raw)) return [];
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      var it = normalize(raw[i]);
      if (it) out.push(it);
    }
    return out;
  }

  function save(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); }
    catch (e) { /* modo privado o cuota llena: no hay nada que hacer */ }
    sync();
  }

  function has(variantId) {
    if (!variantId) return false;
    var items = get(), id = String(variantId);
    for (var i = 0; i < items.length; i++) {
      if (items[i].variantId === id) return true;
    }
    return false;
  }

  function add(raw) {
    var item = normalize(raw);
    if (!item) return false;
    var items = get();
    for (var i = 0; i < items.length; i++) {
      /* Ya estaba: se refresca en su sitio en vez de duplicarlo, así
         un precio viejo guardado desde una tarjeta se corrige al
         volver a guardarlo desde la ficha. */
      if (items[i].variantId === item.variantId) {
        item.addedOn = items[i].addedOn;
        items[i] = item;
        save(items);
        return true;
      }
    }
    items.push(item);
    save(items);
    return true;
  }

  function remove(variantId) {
    var id = String(variantId), items = get(), out = [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].variantId !== id) out.push(items[i]);
    }
    save(out);
    return out.length !== items.length;
  }

  /* Devuelve true si quedó añadido, false si quedó quitado. */
  function toggle(raw) {
    if (raw && raw.variantId && has(raw.variantId)) {
      remove(raw.variantId);
      return false;
    }
    return add(raw);
  }

  function count() {
    return get().length;
  }

  /* El contador del header. Lo pintaban cinco sitios con el mismo
     bucle, y tres de ellos además llamaban a window.vxSyncWishCount,
     que volvía a hacerlo. */
  function syncCount() {
    var n;
    try { n = JSON.parse(localStorage.getItem(KEY) || '[]').length; }
    catch (e) { n = 0; }
    var els = document.querySelectorAll('.vx-wish-count');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      els[i].style.display = n > 0 ? 'flex' : 'none';
    }
    return n;
  }

  /* Los corazones de las tarjetas. Antes cada seccion leia el estado al
     construir la tarjeta y ahi se quedaba: si guardabas algo desde la
     ficha y volvias a la coleccion, el corazon seguia apagado hasta
     recargar. Ahora los repinta quien sabe cuando cambio la lista. */
  function syncHearts(root) {
    var btns = (root || document).querySelectorAll('.vxc-wish-btn[data-vid]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('is-active', has(btns[i].getAttribute('data-vid')));
    }
  }

  function sync(root) {
    syncCount();
    syncHearts(root);
  }

  function format(item) {
    if (!item || !item.priceCents) return '';
    return window.VXMoney ? window.VXMoney.format(item.priceCents) : '';
  }

  /* El precio guardado en las dos monedas, para pintar la lista. Lo guardado
     son dólares, así que el sol es la conversión y lleva «≈»: aquí no llega
     el precio en soles fijado a mano (MONEDA.md §5). Con la moneda apagada,
     el mismo texto que format(). */
  function formatHtml(item) {
    if (!item || !item.priceCents) return '';
    return window.VXMoney ? window.VXMoney.html(item.priceCents, { aprox: true }) : '';
  }

  /* El mismo precio como texto y en la moneda que el cliente está viendo,
     para el mensaje de WhatsApp, que no lleva marcado. */
  function formatText(item) {
    if (!item || !item.priceCents) return '';
    var M = window.VXMoney;
    if (!M) return '';
    if (M.active() === 'pen') {
      var pen = M.toPen(item.priceCents);
      if (pen != null) return '\u2248 ' + M.formatPen(pen);
    }
    return M.format(item.priceCents);
  }

  window.VXWish = {
    KEY: KEY,
    get: get,
    save: save,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    count: count,
    syncCount: syncCount,
    syncHearts: syncHearts,
    sync: sync,
    format: format,
    formatHtml: formatHtml,
    formatText: formatText,
    variantLabel: variantLabel
  };

  /* Compatibilidad: header-vexial.js publicaba este global y lo llaman
     la ficha, colección y destacados. Se mantiene el nombre para no
     dejar llamadas colgando. */
  window.vxSyncWishCount = syncCount;

  /* Otra pestaña tocó la lista. Antes esto solo lo escuchaba el
     header, así que el corazón de una tarjeta se quedaba desfasado. */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) sync();
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) sync();
  });

  /* Primera pintura. Este archivo se carga con defer, o sea que corre
     despues de parsear el HTML: las tarjetas ya estan puestas. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); }, { once: true });
  } else {
    sync();
  }
})();
